import React from 'react';
import _get from 'lodash/get';

import { UiKit } from 'components';
import { useRequestReasonList } from '../context';
import * as RequestReasonConfig from '../../RequestReasonConfig';
import * as RequestReasonToggle from '../../RequestReasonToggle';
import * as RequestReasonDelete from '../../RequestReasonDelete';
import { ReactComponent as PenIcon } from 'assets/ss-icons/pen.svg';

export default function Reason({ data = {} }) {
  const { onUpdateReasons, onReload } = useRequestReasonList();

  const id = _get(data, 'id', '');
  const name = _get(data, 'name', '');

  return (
    <UiKit.Card>
      <UiKit.Card.Body>
        <UiKit.Flex align="center" justify="space-between" gap={24}>
          <RequestReasonToggle.Provider reason={data} onSaved={onUpdateReasons}>
            <UiKit.Flex align="center" gap={16}>
              <RequestReasonToggle.Switch />
              <UiKit.Text weight="bold">{name}</UiKit.Text>
            </UiKit.Flex>
          </RequestReasonToggle.Provider>
          <RequestReasonConfig.Provider reasonId={id} onSaved={onReload}>
            <RequestReasonConfig.Form>
              <RequestReasonDelete.Provider
                reasonId={id}
                onDeleted={() => onUpdateReasons({ id }, 'delete')}
              >
                <RequestReasonDelete.Trigger />
              </RequestReasonDelete.Provider>
            </RequestReasonConfig.Form>
            <RequestReasonConfig.Trigger size="sm">
              <PenIcon />
              Edit
            </RequestReasonConfig.Trigger>
          </RequestReasonConfig.Provider>
        </UiKit.Flex>
      </UiKit.Card.Body>
    </UiKit.Card>
  );
}
